export default new class FilterSelectType {
  constructor() {
    this.ocProductId = '';
    this.selectId = '#property-filter-5';
    this.checkboxName = 'offer_id';

    this.filterId = '';
    this.filterValue = '';
    this.checkboxValue = '';
    this.ajaxData = '';
    this.sizeValue = '';
    this.sizeSelect = $('input[name="offer_id"]');


    // this.init();
  }

  /* init() {
    const typeSelect = $(this.selectId);
    typeSelect.on('change', function change() {
      // leggere da <section class="product-info _shopaholic-product-wrapper" itemscope itemtype="https://schema.org/Product" data-product-id="15">
      // this.ocProductId = $(this).find(':selected').data('product-id');
      this.ocProductId = $('.product-info._shopaholic-product-wrapper').data('product-id');
      this.filterValue = $(this).find(':selected').val();

      this.ajaxData = {
        ocPropertyId: 5,
        ocProductId: this.ocProductId,
        filterValue: this.filterValue,
      };

      $.request('ProductDetailsHelper::onPropertySelect', {
        data: this.ajaxData,
        // loading: $.oc.stripeLoadIndicator,
        flash: 1,
        handleFlashMessage(message, type) {
          $.oc.flashMsg({ text: message, class: type });
        },
        complete() {
          this.checkboxValue = $('input:checked').val();
          $.request('ProductDetailsHelper::onPriceUpdt', {
            data: { offerId: this.checkboxValue },
          });
          // console.log(this.checkboxValue);
        },
      });

    });

    // const sizeSelect = $('input[name="offer_id"]');
    this.sizeSelect.on('change', function change() {
      this.sizeValue = $('input:checked').val();
      $.request('ProductDetailsHelper::onPriceUpdt', {
        data: { offerId: this.sizeValue },
      });
    });
  } */


}();
